import { Link } from "gatsby"
import React from "react"

import Bell from "../../images/icons/wdn-bell.svg"
import Cart from "../../images/icons/wdn-cart.svg"
import { getBaseAddress } from "../../utils/getBaseAddress"

const Icons = ({ state }) => {
  return (
    <>
      {!!state?.user?.company?.id && (
        <span className="mr-4  position-relative">
          <Link
            to={getBaseAddress(state) + "/profile/cart"}
            activeClassName="active"
          >
            <img src={Cart} className="nav-menu-icon" alt="" />
            <span className="notification-count position-absolute">
              {!!state?.candidate_counts
                ? state?.candidate_counts?.cart
                : state?.company_counts?.cart}
            </span>
          </Link>
        </span>
      )}
      <span className=" mr-4  position-relative">
        <Link
          to={getBaseAddress(state) + "/profile/notifications"}
          activeClassName="active"
        >
          <img src={Bell} className="nav-menu-icon" alt="" />
          <span className="notification-count position-absolute">
            {!!state?.candidate_counts
              ? state?.candidate_counts?.notification
              : state?.company_counts?.notification}
          </span>
        </Link>
      </span>
    </>
  )
}

export default Icons
